import React from 'react'

import { HStack } from '~/components/elements/HStack'

import { type StrategyMemo } from '../hooks/useArchivedStrategyMemosInfiniteQuery'

import { DeleteButton } from './DeleteButton'
import { UnarchiveButton } from './UnarchiveButton'

export type CommandsCellProps = {
  dataItem: StrategyMemo
}

export const CommandsCell = ({ dataItem: strategyMemo }: CommandsCellProps) => (
  <td>
    <HStack backgroundColor="transparent" spacing={1}>
      <UnarchiveButton strategyMemo={strategyMemo} />

      <DeleteButton strategyMemo={strategyMemo} />
    </HStack>
  </td>
)
